import { watchGuide } from "@/mocks/siteData";
import Reveal from "@/components/base/Reveal";

export default function GuideSection() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
        <Reveal>
          <div className="relative w-full h-[320px] md:h-[460px] rounded-lg overflow-hidden bg-foreground-950">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20top%20down%20flat%20lay%20of%20a%20review%20notepad%2C%20a%20small%20monitor%20screen%20glowing%20warm%2C%20a%20coffee%20cup%20and%20scattered%20notes%20on%20a%20dark%20wood%20desk%2C%20warm%20amber%20lighting%2C%20no%20people&width=1200&height=1000&seq=fail-guide-01&orientation=landscape"
              alt="翻车事件复盘工作台示意"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent"></div>
            <div className="absolute left-5 right-5 bottom-5">
              <p className="font-heading font-bold text-lg md:text-2xl text-background-50 leading-snug">
                一个事件，三种视角：经过、画面、复盘
              </p>
              <p className="mt-2 text-xs md:text-sm text-background-200">
                编辑逐条核对公开信息后才发布，标注来源，不做定性判断。
              </p>
            </div>
          </div>
        </Reveal>

        <div>
          <p className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600 mb-3 uppercase">
            <span className="w-6 h-px bg-primary-400"></span>
            How to read
          </p>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-tight">
            三分钟看懂一次翻车
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            每篇事件页都按固定结构整理，你不需要从头读到尾，也能抓住重点。
          </p>

          <ol className="mt-8 space-y-5">
            {watchGuide.map((item, index) => (
              <Reveal key={item.step} delay={index * 80}>
                <li className="flex gap-4 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200">
                  <span className="shrink-0 w-11 h-11 rounded-md bg-foreground-950 text-background-50 flex items-center justify-center">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading font-semibold text-base text-foreground-950">
                      <span className="text-primary-500 mr-2">{item.step}</span>
                      {item.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}